import type { PropsWithChildren } from "react";

import "../scss/styles.scss";

export const StylingWrapper = ({ children }: PropsWithChildren) => {
  return children;
};
